'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$8 = require('./styles-4cf0a0ea.js');

var SelectBlock = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, price = _a.price, description = _a.description, onClick = _a.onClick, isSelected = _a.isSelected, index = _a.index, className = _a.className;
    var handleClick = React.useCallback(function () { return onClick(index); }, [onClick, index]);
    return (React__default.createElement(styles$8.SelectContainer, { className: className, onClick: handleClick, role: "button", isSelected: isSelected },
        React__default.createElement(styles$8.TextContainer, null,
            React__default.createElement(styles$8.TitleText, null, title),
            subtitle && React__default.createElement(styles$8.SubtitleText, null, subtitle)),
        React__default.createElement(styles$8.PriceContainer, null,
            price && React__default.createElement(styles$8.Price, null, price),
            description && React__default.createElement(styles$8.DescriptionText, { price: price }, description))));
};

exports.SelectBlock = SelectBlock;
